<template>
  <!-- 系统目录 西成药品 -->
  <div class="MedicenCata">
    <el-tabs type="border-card">
      <el-tab-pane label="患者信息">
        <el-form :model="patientForm" label-width="90px" size="mini" class="compact-form">
          <!-- 第一行 -->
          <el-form-item label="健康ID:">
            <el-input v-model="patientForm.patId" size="mini" :disabled="isInputDisabled" style="width: 150px"
                      @keyup.enter.native="handleSearch" placeholder="输入后回车查询">
            </el-input>
          </el-form-item>

          <el-form-item label="三无:">
            <el-checkbox
                v-model="patientForm.thrNot"
                :true-label="1"
                :false-label="0"
                size="mini">
            </el-checkbox>
          </el-form-item>

          <el-form-item label="姓名:">
            <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 1 }" v-model="patientForm.name"
                      :disabled="isInputDisabled" size="mini" style="width: 100%;"></el-input>
          </el-form-item>

          <el-form-item label="性别:">
            <el-select v-model="patientForm.sex" size="mini" style="width: 70px">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="patientForm.identityCard" size="mini" style="width: 115px" filterable clearable>
              <el-option v-for="item in certypeOption" :key="item.id" :label="item.label"
                         :value="item.id"></el-option>
            </el-select>
            <el-input v-model="patientForm.certno" @blur="certnoMonitor(patientForm)" style="width: 140px"
                      clearable></el-input>
          </el-form-item>

          <el-form-item label="特殊人群:">
            <el-select v-model="patientForm.isSpecial" size="mini" filterable clearable>
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>

          <!-- 第二行 -->
          <el-form-item label="出生日期:">
            <el-date-picker
                v-model="patientForm.brdy"
                type="date"
                size="mini"
                style="width: 140px"
                prefix-icon="none"
                :disabled="true"
                :placeholder="patientForm.identityCard !== 1 ? '' : '身份证自动计算'"
                value-format="yyyy-MM-dd">

            </el-date-picker>
          </el-form-item>

          <el-form-item label="年龄:">
            <div class="age-input-group">
              <el-input v-model="patientForm.ageYear" :disabled="true" size="mini" style="width: 10px;"></el-input>
              <span class="age-unit">岁</span>
              <el-input v-model="patientForm.ageMonth" :disabled="true" size="mini" style="width: 10px;"></el-input>
              <span class="age-unit">月</span>
            </div>
          </el-form-item>

          <el-form-item label="民族:">
            <el-select v-model="patientForm.naty" size="mini" filterable clearable>
              <el-option v-for="item in nationOption" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="职业:">
            <el-select v-model="patientForm.jobId" size="mini" style="width: 130px" filterable clearable>
              <el-option v-for="item in jobOption" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <!-- 第三行 -->
          <el-form-item label="病员费别:">
            <el-select v-model="patientForm.prhCostType" size="mini" style="width: 135px" filterable clearable>
              <el-option v-for="item in this.prhCostOption" :key="item.id" :label="item.label" :value="item.id">
                <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="病员类型:">
            <el-select v-model="patientForm.prhType" size="mini" style="width: 135px">
              <el-option v-for="item in this.prhTypeOption" :key="item.id" :label="item.label" :value="item.id">
                <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="合约单位:">
            <!-- 下拉框组件 -->
            <el-select
                v-model="patientForm.phrUnt"
                size="mini"
                filterable
                clearable
                @focus="getContuntList"
            >
              <!-- 默认选项 -->
              <el-option v-for="item in contractUnitOption" :key="item.id" :label="item.label" :value="item.id">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right">
              <el-button size="mini" type="primary" plain @click.stop="handleEditContractUnit(item)"
                         style="margin-left: 10px">
                修改
              </el-button>
              </span>
              </el-option>
              <el-option :value="undefined" disabled style="cursor: pointer">
                <el-button type="text" @click="handleSaveContractUnit"><i class="el-icon-plus"
                                                                          style="font-weight: bold"></i> 新增合约单位
                </el-button>
              </el-option>
            </el-select>
          </el-form-item>

          <!--        <el-form-item label="次数:">
                    <el-input v-model="patientForm.conerName" size="mini" style="width: 40px"></el-input>
                  </el-form-item>-->

          <el-form-item label="联系人:">
            <el-input v-model="patientForm.conerName" size="mini" style="width: 80px"></el-input>
          </el-form-item>

          <el-form-item label="联系电话:">
            <el-input v-model="patientForm.conerTel" size="mini" style="width: 95px"></el-input>
          </el-form-item>

          <el-form-item label="联系人关系:">
            <el-select v-model="patientForm.conerRltsId" size="mini" filterable clearable style="width: 110px">
              <el-option v-for="item in this.rltsEntitiesOption" :key="item.id" :label="item.label" :value="item.id">
                <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item label="联系地址:" prop="conerAddName" style="margin-bottom: 8px;">
                <div style="display: flex;">
                  <el-cascader
                      ref="conerAddCodeArrRef"
                      :key="addressKey"
                      v-model="patientForm.conerAddCodeArr"
                      :props="addressProps"
                      :options="provinces"
                      @focus="initAddressData"
                      :placeholder="conerPleasett"
                      style="width: 400px;"
                  />
                  <el-input
                      v-model="patientForm.conerAddName"
                      placeholder="请输入门牌号"
                      style="width: 300px; margin-left: -1px;"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="position: relative; height: 30px; margin-left: 15px"
               v-if="$store.getters.hasPermission('system:docphr:edit')">  <!-- 清除浮动 -->
            <el-button

                type="primary"
                @click="handleEditDocphr"
                size="mini"
                style=" position: absolute; margin-top: 0;"
            >
              修改
            </el-button>
            <el-tooltip
                content="若查询信息不对,可重新填写后点此按钮更改"
                placement="top"
                style="position: absolute; left: 60px; top: 0;"
            >
              <i class="el-icon-question" style="color: #909399; cursor: pointer;"></i>
            </el-tooltip>
          </div>
          <div class="divider-line"></div> <!-- 分隔线 -->
          <el-form-item label="挂号日期:">
            <el-date-picker
                v-model="patientForm.registerDate"
                type="date"
                size="mini"
                style="width: 140px"
                prefix-icon="none"
                @change="loadData"
                :clearable="false"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>

          <!--        <el-form-item label="挂号类别:" class="register-item">
                    <el-select v-model="patientForm.registerType" size="mini" filterable clearable style="width: 200px"
                               @focus="getRegisterType" @change="getRegisterTypeData" @clear="handleCloseRegisterType">
                      <el-option v-for="item in this.registerOptions" :key="item.id" :label="item.label" :value="item.id">
                        <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">金额:{{ item.odcost }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>-->

          <el-form-item label="时段:">
            <el-select v-model="patientForm.timeSlot" size="mini"
                       filterable @change="getTimeFrameData">
              <el-option label="上午" value="1"></el-option>
              <el-option label="下午" value="2"></el-option>
              <el-option label="晚上" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="科室:">
            <el-select v-model="patientForm.department" size="mini"
                       filterable clearable @focus="getDeptList" @change="loadData">
              <el-option v-for="item in this.deptOptions" :key="item.id" :label="item.label" :value="item.id">
                <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <!--        <el-form-item label="医生:">
                    <el-select v-model="patientForm.doctor" size="mini" @clear="handleCloseDoctor"
                               filterable clearable @focus="getDoctorList" @change="getDoctorReservation">
                      <el-option v-for="item in this.doctorOptions" :key="item.id" :label="item.label" :value="item.id">
                        <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>-->

        </el-form>
      </el-tab-pane>
    </el-tabs>

    <el-tabs type="border-card">
      <el-tab-pane label="挂号列表">
        <div class="table-container">
          <el-table
              :data="tableData"
              border
              @row-click="handleRowClick"
              highlight-current-row
              style="width: 100%;height: 60%"
              height="100%">
            <el-table-column
                header-align="center"
                align="center"
                v-for="(col, inx) in tableRows"
                :key="inx"
                :type="col.type"
                :prop="col.prop"
                :label="col.name"
                :render-header="labelHead"
                :min-width="getColumnWidth(col.label,col.prop,tableData)">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row, 0) }}
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                fixed="left"
                label="行号"
                type="index"
                width="50px"
                align="center">
            </el-table-column>
          </el-table>
          <div class="custom-dialog-footer" style="padding: 10px 0;">
            <!-- 左侧按钮组 -->
            <div class="left-buttons" style="margin-left: 30px;">
              <!--        <el-button type="primary" @click="handleChoosePatient" size="small" :loading="loading">预约信息</el-button>-->

              <!--        <el-button type="primary" @click="handleChoosePatient" size="small" :loading="loading">换健康卡</el-button>
                      <el-button type="primary" @click="handleChoosePatient" size="small" :loading="loading">发健康卡</el-button>-->
            </div>

            <!-- 右侧按钮组 -->
            <div class="footer-container">
              <div class="footer-buttons">
                <!-- 医保按钮带下拉单选框 -->
                <el-dropdown @command="handleYbSwipingCardOrHumanFace" trigger="click"
                             v-if="this.userInfo?.isInsurance === '1'">
                  <el-button type="primary" size="small">
                    医保<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" class="yb-dropdown-menu">
                    <el-dropdown-item command="face">
                      <el-radio label="1">人脸识别</el-radio>
                    </el-dropdown-item>
                    <el-dropdown-item command="electronic">
                      <el-radio label="2">电子医保</el-radio>
                    </el-dropdown-item>
                    <el-dropdown-item command="YbCard">
                      <el-radio label="3">医保刷卡</el-radio>
                    </el-dropdown-item>

                    <el-dropdown-item command="identityCard" :disabled="this.patientForm.certno === ''">
                      <el-radio label="4" :disabled="this.patientForm.certno === ''">身份证认证</el-radio>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary" @click="handleCelerityFiling" size="small" :loading="loading">快速建档
                </el-button>
                <el-button type="primary" @click="handleCloseForm" size="small" :loading="loading">重建</el-button>
                <el-button
                    type="success"
                    v-if="$store.getters.hasPermission('system:register:add')"
                    @click="handleReservationSettle"
                    size="small">
                  结算
                </el-button>
              </div>
            </div>
          </div>
        </div>

      </el-tab-pane>
    </el-tabs>
    <div class="dialog">
      <!--新增往来单位-->
      <el-dialog :title="addUnitForm.id  == null ?'新增合约单位':'修改合约单位'" :before-close="handleCancelContract"
                 :visible.sync="addUnitModalVisible" class="addUnitDialog" width="50%" :close-on-click-modal="false">
        <div class="aform">
          <!-- 表单 -->
          <el-form :model="addUnitForm" label-width="90px" size="mini" :rules="addUnitRules" ref="addUnitRef">
            <el-row :gutter="20">
              <el-col :span="v.spanRows" type="flex" v-for="(v,i) in addUnitType" :key="i"
                      :style="{ marginLeft: v.modelValue === 'uscc' ? '18px' : '0' }">
                <!-- input -->
                <el-form-item v-if="v.type === 'input'" :required="['code', 'name'].includes(v.modelValue)"
                              :label="v.label" :style="v.modelValue === 'uscc' ? 'white-space: nowrap' : ''">
                  <el-input :suffix-icon='v.prefix' v-model="$data.addUnitForm[v.modelValue]"
                            @input="handleNameChangeCode(v,i)" :disabled="v.modelValue === 'code' ? true : null"
                            :style="{ marginLeft: v.modelValue === 'uscc' ? '30px' : '0' }">

                  </el-input>
                </el-form-item>
                <!-- select -->
                <el-form-item v-if="v.type === 'select'" :label="v.label">
                  <el-select v-model="$data.addUnitForm[v.modelValue]" filterable
                             :disabled="v.modelValue === 'untAtte'">
                    <el-option v-for="item in $data[v.op]" :key="item.id" :label="item.label" :value="item.id">
                      <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 新增的按钮区域 - 并排显示（添加在前，取消在后） -->
            <el-form-item style="margin-top: 20px; text-align: right">
              <el-button type="primary" size="mini" @click="handleAddContractUnit">
                {{ addUnitForm.id == null ? '新增' : '修改' }}
              </el-button>
              <el-button size="mini" @click="handleCancelContract" style="margin-left: 10px">取消</el-button>
            </el-form-item>
          </el-form>
        </div>

      </el-dialog>

      <!--挂号支付窗口-->
      <!--挂号支付窗口-->
      <el-dialog
          title="挂号支付"
          :visible.sync="addModalVisible"
          width="800px"
          :close-on-click-modal="false"
          :before-close="handleCloseConfirmPay"
          class="payment-dialog"
      >
        <el-form :model="addForm" label-width="100px" class="payment-form">
          <div class="form-section">
            <!-- 动态生成支付方式 -->
            <template v-if="dynamicPaymentMethods.length > 0">
              <el-row
                  v-for="(row, index) in dynamicPaymentRows"
                  :key="index"
                  :gutter="20"
                  class="payment-row"
              >
                <el-col
                    v-for="method in row"
                    :key="method.id"
                    :span="8"
                >
                  <el-form-item
                      :label="method.wayName + ':'"
                      class="payment-item"
                  >
                    <el-input-number
                        v-model="dynamicPaymentValues[method.id]"
                        :min="0"
                        :precision="2"
                        :step="0.01"
                        :controls="false"
                        @change="calculateRegistrationPayments"
                        :controls-position="'right'"
                        size="mini"
                        style="width: 100%">
                    </el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <div v-else style="text-align: center; padding: 20px; color: #999;">
              正在加载支付方式...
            </div>

            <!-- 结算信息 -->
            <div class="payment-summary">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="应付金额:" class="compact-item">
                    <span class="amount">{{ addForm.currentTotal || patientForm.total }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="收到金额:" class="compact-item">
                    <el-input
                        ref="recdAmt"
                        size="mini"
                        v-model="addForm.recdAmt"
                        class="compact-input"
                        disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="应退找零金额:" class="compact-item">
                    <span class="amount">{{ addForm.change }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 备注 -->
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注:">
                <el-input size="mini" type="textarea" v-model="addForm.remarks"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 按钮组 -->
          <div class="form-actions">
            <el-button type="primary" @click="handleConfirmRegistrationPay">确认支付</el-button>
            <el-button type="warning" @click="handleCloseConfirmPay">退出支付</el-button>
          </div>
        </el-form>
      </el-dialog>

      <!--患者选择-->
      <el-dialog
          title="患者选择"
          :visible.sync="patientDialogVisible"
          width="60%"
          :before-close="handleCloseChoosePatient"
          class="patient-dialog"
      >
        <!-- 患者表格 - 固定高度，超出部分滚动 -->
        <el-table
            :data="patientTabelData"
            border
            highlight-current-row
            @row-dblclick="handleChoosePatient"
            @current-change="handleClickRow"
            style="width: 100%;"
            height="400px"
        >
          <el-table-column v-for="(col, inx) in tableRows2" :key="inx" :type="col.type" :prop="col.prop"
                           :label="col.name" :render-header="labelHead" align="center"
                           :min-width="getColumnWidth(col.label,col.prop,patientTabelData)">
            <template #default="{ row }">
              {{ safeGetMappedValue(col, row) }}
            </template>
          </el-table-column>
        </el-table>

        <div class="dialog-footer no-line">
          <el-button @click="handleCloseChoosePatient" size="mini">取消</el-button>
          <el-button type="primary" @click="handleChoosePatient" size="mini" :loading="loading">确定</el-button>
        </div>
      </el-dialog>

      <!--快速建档-->
      <el-dialog
          :close-on-click-modal="false"
          title="快速建档-新增健康档案"
          :visible.sync="celerityFilingDialogVisible"
          width="50%"
          @close="handleCloseCelerityFiling"
          class="patient-dialog"
      >
        <el-form :model="celerityFilingForm" ref="celerityFilingFormRef" :rules="celerityFilingFormRules"
                 label-width="90px" size="mini" class="compact-form">

          <!-- 第一行 -->
          <el-form-item label="姓名:" prop="name">
            <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 1 }" v-model="celerityFilingForm.name"
                      size="mini" style="width: 100%;"></el-input>
          </el-form-item>

          <el-form-item label="性别:" prop="sex">
            <el-select v-model="celerityFilingForm.sex" size="mini" style="width: 70px">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="identityCard">
            <el-select v-model="celerityFilingForm.identityCard" @input="" size="mini" style="width: 115px" filterable
                       clearable>
              <el-option v-for="item in certypeOption" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
            <el-input v-model="celerityFilingForm.certno" prop="certno" style="width: 200px"
                      @blur="certnoMonitor(celerityFilingForm)"
                      clearable :maxlength="certLengthMap[celerityFilingForm.identityCard]" show-word-limit/>
          </el-form-item>

          <el-form-item label="三无:" prop="thrNot">
            <el-checkbox
                v-model="celerityFilingForm.thrNot"
                :true-label="1"
                :false-label="0"
                @change="handleThrNotChange"
                size="mini">
            </el-checkbox>
          </el-form-item>

          <!-- 第二行 -->
          <el-form-item label="出生日期:" prop="brdy">
            <el-date-picker
                v-model="celerityFilingForm.brdy"
                type="date"
                size="mini"
                style="width: 140px"
                :disabled="celerityFilingForm.identityCard === 1"
                prefix-icon="none"
                :placeholder="celerityFilingForm.identityCard === 1 ? '' : '身份证自动计算'"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="年龄:" prop="ageYear" style="margin-left: 20px;">
            <div class="age-input-group">
              <el-input
                  v-model="celerityFilingForm.ageYear"
                  :disabled="celerityFilingForm.identityCard === 1"
                  size="mini"
                  style="width: 40px;"
              />
              <span class="age-unit">岁</span>
              <el-input
                  v-model="celerityFilingForm.ageMonth"
                  prop="ageMonth"
                  :disabled="true"
                  size="mini"
                  style="width: 40px;"
              />
              <span class="age-unit">月</span>
            </div>
          </el-form-item>

          <el-form-item label="国籍:" prop="ntlyId">
            <el-select v-model="celerityFilingForm.ntlyId" size="mini" filterable clearable>
              <el-option v-for="item in ntlyOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="民族:" prop="naty">
            <el-select v-model="celerityFilingForm.naty" size="mini" filterable clearable>
              <el-option v-for="item in nationOption" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="职业:" prop="jobId">
            <el-select v-model="celerityFilingForm.jobId" size="mini" style="width: 130px" filterable clearable>
              <el-option v-for="item in jobOption" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="病员类型:" prop="prhType">
            <el-select v-model="celerityFilingForm.prhType" size="mini" style="width: 135px">
              <el-option v-for="item in this.prhTypeOption" :key="item.id" :label="item.label" :value="item.id">
                <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="合约单位:" prop="phrUnt">
            <el-select
                v-model="celerityFilingForm.phrUnt"
                size="mini"
                filterable
                clearable
                @focus="getContuntList"
            >
              <el-option v-for="item in contractUnitOption" :key="item.id" :label="item.label" :value="item.id">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right">
          <el-button size="mini" type="primary" plain @click.stop="handleEditContractUnit(item)"
                     style="margin-left: 10px">
            保存
          </el-button>
          <el-tooltip content="若查询信息不对,可重新填写后点此按钮更改" placement="top" style="margin-left: 8px;">
            <i class="el-icon-question" style="color: #909399; cursor: pointer;"></i>
          </el-tooltip>
        </span>
              </el-option>
              <el-option :value="undefined" disabled style="cursor: pointer">
                <el-button type="text" @click="handleSaveContractUnit">
                  <i class="el-icon-plus" style="font-weight: bold"></i> 新增合约单位
                </el-button>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="联系人:" prop="conerName">
            <el-input v-model="celerityFilingForm.conerName" size="mini" style="width: 80px"></el-input>
          </el-form-item>

          <el-form-item label="联系电话:" prop="conerTel">
            <el-input v-model="celerityFilingForm.conerTel" size="mini" style="width: 95px"></el-input>
          </el-form-item>

          <el-form-item label="联系人关系:" prop="conerRltsId">
            <el-select v-model="celerityFilingForm.conerRltsId" size="mini" filterable clearable style="width: 110px">
              <el-option v-for="item in this.rltsEntitiesOption" :key="item.id" :label="item.label" :value="item.id">
                <span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="联系地址:" prop="conerAddName" style="margin-bottom: 8px; width: 100%">
            <div style="display: flex;">
              <el-cascader
                  ref="conerAddCodeArrRef"
                  :key="addressKey"
                  v-model="celerityFilingForm.conerAddCodeArr"
                  :props="addressProps"
                  :options="provinces"
                  @focus="initAddressData"
                  :placeholder="celerityConerPleasett"
                  style="width: 400px;"
              />
              <el-input
                  v-model="celerityFilingForm.conerAddName"
                  placeholder="请输入门牌号"
                  style="width: 100%; margin-left: -1px;"
              />
            </div>
          </el-form-item>

        </el-form>
        <div class="celerity-filing-button" style="margin-left: 100px;">
          <el-button size="mini" type="warning" @click="handleResetContract">
            重置
          </el-button>
          <el-button type="primary" @click="handleIdCardData" size="mini">身份证读取</el-button>
          <el-button type="primary" @click="handleAddCelerityFiling" size="mini">保存</el-button>
          <el-button @click="handleCloseCelerityFiling" size="mini">取消</el-button>
        </div>
      </el-dialog>

      <!--付款码支付窗口-->
      <el-dialog
          title="请扫描患者付款码"
          :visible.sync="payModalVisible"
          width="30%"
          :close-on-click-modal="false"
          @opened="handlePayDialogOpened"
          @closed="handlePayDialogClosed">

        <!-- 隐藏的扫码输入框 -->
        <div style="position: absolute; left: -9999px;">
          <el-input
              ref="paymentCodeInput"
              v-model="paymentCode"
              @input="handleScanComplete">
          </el-input>
        </div>

        <!-- 可视化提示区域 -->
        <div style="text-align: center; padding: 20px 0;">
          <!-- 状态1：等待扫码 -->
          <template v-if="scanStatus === 'waiting'">
            <i class="el-icon-loading" style="font-size: 40px;"></i>
            <p style="margin-top: 15px;">请使用扫码枪扫描顾客付款码</p>
          </template>

          <!-- 状态2：处理中 -->
          <template v-else-if="scanStatus === 'processing'">
            <i class="el-icon-loading" style="font-size: 40px;"></i>
            <p style="margin-top: 15px;">正在处理付款请求...</p>
          </template>

          <!-- 状态3：处理成功 -->
          <template v-else-if="scanStatus === 'success'">
            <i class="el-icon-success" style="font-size: 40px; color: #67C23A;"></i>
            <p style="margin-top: 15px;">
              付款成功！{{ countdown }}秒后自动关闭
            </p>
            <el-progress
                :percentage="countdown * 20"
                status="success"
                style="width: 80%; margin: 10px auto;"
            ></el-progress>
          </template>

          <template v-else-if="scanStatus === 'error'">
            <i class="el-icon-error" style="font-size: 40px; color: #F56C6C;"></i>
            <p style="margin-top: 15px;">{{ errorMessage }}</p>
            <p style="margin-top: 10px; color: #999;">{{ countdown }}秒后重新开始扫码</p>
            <el-progress
                :percentage="countdown * 20"
                status="exception"
                style="width: 80%; margin: 10px auto;"
            ></el-progress>
          </template>
        </div>
      </el-dialog>

      <!--医保电子凭证扫码窗口-->
      <el-dialog
          title="请扫描患者电子医保"
          :visible.sync="ybElectronicCertificatesModalVisible"
          width="30%"
          :close-on-click-modal="false"
          @opened="handleYbElectronicCertificatesOpened"
          @closed="handleYbElectronicCertificatesDialogClosed">

        <!-- 隐藏的扫码输入框 -->
        <div style="position: absolute; left: -9999px;">
          <el-input
              ref="YbElectronicCertificatesCodeInput"
              v-model="YbElectronicCertificatesCode"
              @keyup.enter.native="handleYbScanComplete">
          </el-input>
        </div>

        <!-- 可视化提示区域 -->
        <div style="text-align: center; padding: 20px 0;">
          <!-- 状态1：等待扫码 -->
          <template v-if="ybScanStatus === 'waiting'">
            <i class="el-icon-loading" style="font-size: 40px;"></i>
            <p style="margin-top: 15px;">请使用扫码枪扫描医保电子凭证</p>
          </template>

          <!-- 状态2：处理中 -->
          <template v-else-if="ybScanStatus === 'processing'">
            <i class="el-icon-loading" style="font-size: 40px;"></i>
            <p style="margin-top: 15px;">正在处理...</p>
          </template>

          <!-- 状态3：处理成功 -->
          <template v-else-if="ybScanStatus === 'success'">
            <i class="el-icon-success" style="font-size: 40px; color: #67C23A;"></i>
            <p style="margin-top: 15px;">
              扫描成功！{{ ybScanCountdown }}秒后自动关闭
            </p>
            <el-progress
                :percentage="ybScanCountdown * 20"
                status="success"
                style="width: 80%; margin: 10px auto;"
            ></el-progress>
          </template>

          <template v-else-if="ybScanStatus === 'error'">
            <i class="el-icon-error" style="font-size: 40px; color: #F56C6C;"></i>
            <p style="margin-top: 15px;">{{ ybErrorMessage }}</p>
            <p style="margin-top: 10px; color: #999;">{{ ybScanCountdown }}秒后重新开始扫码</p>
            <el-progress
                :percentage="ybScanCountdown * 20"
                status="exception"
                style="width: 80%; margin: 10px auto;"
            ></el-progress>
          </template>
        </div>
      </el-dialog>

      <el-dialog
          title="医疗类别信息"
          :visible.sync="outpatientYbRegisterDialogVisible"
          width="20%"
          :before-close="handleOutpatientYbRegisterClose">

        <el-form
            :model="outpatientYbRegisterForm"
            :rules="outpatientYbRegisterFormRules"
            ref="outpatientForm"
            label-width="140px"
            size="mini">
          <el-row :gutter="20">
            <!-- 医疗类别 -->
            <el-col :span="24">
              <el-form-item label="医疗类别:" prop="med_type">
                <el-select v-model="outpatientYbRegisterForm.med_type">
                  <el-option
                      v-for="item in medTypeOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="疾病诊断:" prop="dise_codg">
                <el-select
                    v-model="outpatientYbRegisterForm.dise_codg"
                    filterable
                    remote
                    :remote-method="handleSearchWestDiagnose"
                    :loading="westDiagnoseLoading"
                    placeholder="请输入疾病名称搜索"
                    @change="handleGetWestDiagnose">
                  <el-option
                      v-for="item in westDiagnoseOptions"
                      :key="item.id"
                      :label="`${item.label}-(${item.code})`"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 个人结算方式 -->
            <el-col :span="24">
              <el-form-item label="个人结算方式:" prop="psnSetlway">
                <el-select v-model="outpatientYbRegisterForm.psnSetlway">
                  <el-option
                      v-for="item in psnSetlwayOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 个人账户使用标志 -->


            <el-col :span="24">
              <el-form-item label="就诊开始时间:" prop="begntime">
                <el-date-picker
                    v-model="outpatientYbRegisterForm.begntime"
                    type="datetime"
                    placeholder="选择就诊开始时间"
                    class="no-icon-datepicker"
                    style="width: 100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="个人账户使用标志:" prop="acct_used_flag">
                <el-select v-model="outpatientYbRegisterForm.acct_used_flag">
                  <el-option
                      v-for="item in acctUsedFlagOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>

        <span slot="footer">
        <el-button @click="handleOutpatientYbRegisterClose" size="mini">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleYBInfoUpload">确 定</el-button>
      </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  addContractUnit,
  addDocphr,
  addRegisterList,
  addYbRegistrationSettleAccounts,
  dict,
  editContractUnit,
  editDocphr,
  getActiveList,
  getArea,
  getConsultingDepartment,
  getContractUnit,
  getContuntList,
  getDeptOfDoctor,
  getDocphrList,
  getDoctorList,
  getRegisterType,
  getYbRegistrationSettleAccounts, registrationFee,
  updateYbRegistrationSettleAccounts
} from "@/api/reservation/reservation";
import AddType from './reservationAddType.js';
import AddType2 from './reservationSettleType.js';
import {pinyin} from "pinyin-pro";
import AddressSelector from "@/views/reservation/AddressSelector.vue";
import {sqbPayment} from "@/api/reservation/outpatientCharge";
import dayjs from "dayjs";
import {getDocticdList, getDoesItExistSFZ} from "@/api/reservation/outpatientPhysician";
import {readIdCard} from "@/untils/idCardReader";
import {getNationalityId} from "@/untils/outpatientPhysicianUntils";
import {withLoading} from "@/untils/loading";
import {addYbResponseData, addYbRquestData, getqdNo} from "@/api/yb";
import {buildYbRequest} from "@/api/yb/ybApi";
import {getCategory} from "@/api/Outpatient/category";
import {handleYB_1101_Upload, handleYB_Business_Upload} from "@/api/yb/ocxActiveXApi";
import ybOutpatientMedical from '@/untils/ybOutpatientMedical';
import {getPatternPaymentList} from "@/api/patternPayment/patternPayment";

// 工厂函数：生成空的患者表单
const getEmptyPatientForm = () => ({
  id: null,
  patId: '',
  thrNot: false,
  name: '',
  sex: null,
  identityCard: 1,
  certno: '',
  brdy: '',
  ageYear: null,
  ageMonth: null,
  naty: '汉族',
  jobId: null,
  feeType: null,
  prhType: null,
  contractUnit: null,
  isSpecial: '否',
  conerName: '',
  conerTel: '',
  conerRltsId: null,
  province: '',
  city: '',
  county: '',
  town: '',
  village: '',
  registerDate: dayjs().format('YYYY-MM-DD'),
  timeSlot: null,
  department: null,
  doctor: null,
  registerType: null,
  clinicRoom: null,
  existNumber: null,
  currentNumber: null,
  caseHistory: null,
  total: null,
  naplAddCode: null,
  conerAddCode: null,
  number: null,
  conerAddName: null,
  conerAddCodeArr: [],
  phrUnt: null,
  prhCostType: null,
  odcost: null,
});

// 工厂函数：生成空的挂号支付表单
const getEmptyAddForm = () => ({
  discountMoney: null,
  name: '',
  patientId: null,
  payType: null,
  receivableMoney: null,
  receivedMoney: null,
  regDepId: null,
  regDoctorId: null,
  regMode: null,
  regNum: null,
  regTypeId: null,
  regUserId: null,
  remake: '',
  utyTimeDetailsId: null,
  visitId: null,
  rgstId: null,
  accountNumber: null,
  currentNumber: null,
  oweNumber: '0/0',
  remark: null,
  feeType: null,
  MoneyPay: null,
  healthCarePay: null,
  fitnessCardpa: null,
  unionPay: null,
  owePay: null,
  phonePay: null,
  discountsNumb: null,
  receivableNum: null,
  receiveNumber: null,
  changeNumber: null,
  remarks: null,
  cashAmt: null,
  currentTotal: null,
  recdAmt: null,
  chsAmt: null,
  credit: null,
  observation: null,
  patAmt: null,
  bankAmt: null,
  distAmt: null,
  bebtAmt: null,
  groupAmt: null,
  observationAdvance: null,
  change: null,
  age: null,
  regTableVOS: [],
  regTime: '',
});

// 工厂函数：生成空的快速建档表单
const getEmptyCelerityFilingForm = () => ({
  name: '',
  sex: null,
  identityCard: 1,
  certno: '',
  brdy: '',
  ageYear: null,
  ageMonth: null,
  ageDay: 0,
  naty: 1,
  ntlyId: 1,
  jobId: '',
  prhType: null,
  contractUnit: null,
  conerName: '',
  conerTel: '',
  conerRltsId: null,
  province: '',
  city: '',
  county: '',
  town: '',
  village: '',
  tel: null,
  restAddCode: null,
  naplAddCode: null,
  conerAddCodeArr: [],
  conerAddName: '',
  thrNot: null,
  phrUnt: null,
});

// 工厂函数：生成空的合约单位表单
const getEmptyAddUnitForm = () => ({
  id: null,
  code: dayjs().format('YYYYMMDDHHmmss'),
  state: 1,
  area: 1,
  name: '',
  pyCode: '',
  bankName: '',
  bankNo: '',
  splerPmtno: '',
  legalRepe: '',
  mainConer: '',
  conerPhone: '',
  conerTel: '',
  conerQq: '',
  conerFax: '',
  conerPostc: '',
  url: '',
  conerMail: '',
  untAtte: 3,
  uscc: '',
  conerAdd: '',
  remark: ''
});

// 证件长度映射
const certLengthMap = {
  1: 18, 2: 20, 3: 9, 4: 10, 5: 12, 6: 11, 7: 10, 8: 18, 9: 20
};
// 证件格式验证规则
const certPatterns = {
  1: /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/,
  2: /^[A-Za-z0-9\u4e00-\u9fa5]{1,20}$/,
  3: /^[A-Za-z]\d{7,8}$/,
  4: /^[A-Za-z0-9\u4e00-\u9fa5]{1,10}$/,
  5: /^\d{12}$/,
  6: /^[HMhm]\d{8,10}$/,
  7: /^\d{8}[A-Za-z]{2}$/,
  8: /^WJ\d{6}\d{11}$/,
  9: /^[A-Za-z0-9\u4e00-\u9fa5]{1,20}$/
};

export default {
  components: {AddressSelector},
  data() {
    return {
      // 基础数据
      activeTab: 'patientInfo',
      conerPleasett: '',
      celerityConerPleasett: '',
      addressKey: 0,
      userInfo: null,
      loading: false,
      isInputDisabled: false,
      terminalId: null,
      orderId: null,
      signNo: null,
      mdtrt_id: null,
      rowData: {},
      selectedValues: [],
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,
      pageDataState: null,
      addcategory: [],
      itemPriceOptions: [],

      // 对话框控制
      patientDialogVisible: false,
      addModalVisible: false,
      celerityFilingDialogVisible: false,
      payModalVisible: false,
      ybElectronicCertificatesModalVisible: false,
      addUnitModalVisible: false,
      outpatientYbRegisterDialogVisible: false,

      // 扫码支付相关
      paymentCode: '',
      YbElectronicCertificatesCode: '',
      scanTimer: null,
      isProcessing: false,
      isSuccess: false,
      scanStatus: 'waiting',
      ybScanStatus: 'waiting',
      errorMessage: '付款失败,请重试',
      ybErrorMessage: '扫描医保电子凭证失败,请重试',
      countdown: 5,
      ybScanCountdown: 5,
      countdownStartTime: 0,
      ybScanCountdownStartTime: 0,
      animationFrameId: null,
      ybScanAnimationFrameId: null,

      // 表单数据
      patientForm: getEmptyPatientForm(),
      addForm: getEmptyAddForm(),
      celerityFilingForm: getEmptyCelerityFilingForm(),
      addUnitForm: getEmptyAddUnitForm(),
      celerityFilingFormRules: {
        name: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('姓名不能为空')); else callback();
          }, trigger: 'blur'
        }],
        sex: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('请选择性别')); else callback();
          }, trigger: 'change'
        }],
        certno: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('证件号码不能为空')); else callback();
          }, trigger: 'blur'
        }],
        brdy: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('出生日期不能为空')); else callback();
          }, trigger: 'change'
        }],
        ntlyId: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('请选择国籍')); else callback();
          }, trigger: 'change'
        }],
        naty: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('请选择民族')); else callback();
          }, trigger: 'change'
        }],
        jobId: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('请选择职业')); else callback();
          }, trigger: 'change'
        }],
        prhType: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('请选择病员类型')); else callback();
          }, trigger: 'change'
        }],
        conerName: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('联系人不能为空')); else callback();
          }, trigger: 'blur'
        }],
        conerTel: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('联系电话不能为空')); else {
              const reg = /^1[3-9]\d{9}$|^0\d{2,3}-\d{7,8}$/;
              if (!reg.test(value)) callback(new Error('请输入正确的电话号码')); else callback();
            }
          }, trigger: 'blur'
        }],
        conerRltsId: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('请选择联系人关系')); else callback();
          }, trigger: 'change'
        }],
        conerAddName: [{
          required: true, validator: (rule, value, callback) => {
            if (this.celerityFilingForm.thrNot !== 1 && !value) callback(new Error('联系地址不能为空')); else callback();
          }, trigger: 'blur'
        }]
      },
      addUnitRules: {
        code: [{required: true, message: '请填写合约单位编码！', trigger: 'change'}],
        name: [{required: true, message: '请填写合约单位名称！', trigger: 'change'}]
      },
      outpatientYbRegisterFormRules: {
        med_type: [{required: true, message: '请选择医疗类别', trigger: 'change'}],
        psnSetlway: [{required: true, message: '请选择个人结算方式', trigger: 'change'}],
        acct_used_flag: [{required: true, message: '请选择个人账户使用标志', trigger: 'change'}],
        begntime: [{required: true, message: '请选择就诊开始时间', trigger: 'change'}],
        dise_codg: [{required: true, message: '请选择疾病诊断', trigger: 'change'}]
      },
      outpatientYbRegisterForm: {
        med_type: '11',
        psnSetlway: '01',
        acct_used_flag: '1',
        dise_codg: '不适-R53.x00x005',
        begntime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        yb_1101_ReturnInfo: {},
        yb_1191_ReturnInfo: {},
        yb_2201A_ReturnInfo: {},
        yb_2203_ReturnInfo: {},
        yb_2204_ReturnInfo: {},
        yb_2206_ReturnInfo: {},
        yb_2207_ReturnInfo: {},
      },
      patientChooseForm: {
        id: null,
        patId: '',
        name: '',
        sex: null,
        certno: null,
        conerTel: null,
        contractUnit: null,
        healthCardNo: null,
        cardType: null,
      },
      westDiagnoseOptions: [],
      westDiagnoseLoading: false,
      dynamicPaymentMethods: [],
      dynamicPaymentValues: {},
      isRequesting: false,
      certLengthMap,
      certPatterns,
      // 下拉选项数据
      provinces: [],
      cityOption: [],
      countyOption: [],
      townOption: [],
      villageOption: [],
      prhCostOption: [],
      prhTypeOption: [],
      rltsEntitiesOption: [],
      jobOption: [],
      contractUnitOption: [],
      untAtteOption: [],
      deptOptions: [],
      doctorOptions: [],
      registerOptions: [],
      ntlyOptions: [],
      acctUsedFlagOptions: [],
      medTypeOptions: [],
      psnSetlwayOptions: [],
      addUnitType: AddType.map(v => v),
      addType: AddType2.map(v => v),
      nationOption: [],
      certypeOption: [],
      profttlOption: [],
      feeTypeOption: [],
      payTypeOption: [{id: 1, label: '现金'}, {id: 2, label: '支付宝'}, {id: 3, label: '微信'}, {
        id: 4,
        label: '银行卡'
      }, {id: 5, label: '医保'}, {id: 6, label: '优惠支付'}, {id: 7, label: '健康卡支付'}],
      systemParameterList: [],
      // 表格数据
      patientTabelData: [],
      tableData: [],
      tableRows: [
        {name: "科室名称", prop: "deptName"},
        {name: "医生姓名", prop: "doctorName"},
        {name: "职称", prop: "professionalTitle"},
        {name: "挂号类别", prop: "registertypeName"},
        {name: "挂号金额", prop: "price"},
        {name: "上午时段", prop: "amTime"},
        {name: "下午时段", prop: "pmTime"},
        {name: "晚上时段", prop: "nightTime"},
        {name: "限号", prop: "limitNum"},
        {name: "余号", prop: "remainingNum"},
        {name: "已挂", prop: "useNum"}
      ],
      tableRows2: [
        {name: "健康ID", prop: "id"},
        {name: "健康卡号", prop: "patId"},
        {name: "姓名", prop: "name"},
        {name: "身份证号", prop: "certno"},
        {name: "联系电话", prop: "conerTel"}
      ],
      addressProps: {
        lazy: true,
        value: 'areaCode',
        label: 'areaName',
        emitPath: true,
        leaf: node => node.areaLevel >= 5,
        lazyLoad: async (node, resolve) => {
          const level = node.level + 1;
          if (level > 5) return resolve([]);
          const params = {
            areaCode: node.level > 0 ? node.data.areaCode : undefined,
            areaLevel: level,
            condtion: ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code', 'area_t_code'][level - 1]
          };
          const res = await getArea(params);
          const formattedData = (res?.data || []).map(item => ({
            ...item,
            value: item.areaCode,
            label: item.areaName,
            level,
            isLeaf: level >= 5
          }));
          resolve(formattedData);
        }
      }
    };
  },
  computed: {
    isYbButtonDisabled() {
      return !this.userInfo || this.userInfo.isInsurance !== '1';
    },
    dynamicPaymentRows() {
      const rows = [];
      for (let i = 0; i < this.dynamicPaymentMethods.length; i += 3) rows.push(this.dynamicPaymentMethods.slice(i, i + 3));
      return rows;
    }
  },
  watch: {
    'patientForm.certno'(newVal, oldVal) {
      if (newVal !== oldVal) this.outpatientYbRegisterForm = {...this.$options.data.call(this).outpatientYbRegisterForm};
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyPress);
  },
  created() {
    this.patientForm.timeSlot = this.getCurrentTimeSlot();
  },
  async mounted() {
    if (!this.$store.state.dict || Object.keys(this.$store.state.dict).length === 0) {
      await this.$store.dispatch('fetchDictData');
      await this.dict(this.$store.state.dict);
    } else {
      await this.dict(this.$store.state.dict);
    }
    await this.loadPaymentMethods();
    await this.loadData();
    this.contractUnitOption = this.$store.getters['preload/getContuntListOptions'] || [];
    this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'] || [];
    this.systemParameterList = this.$store.getters['preload/getSystemListOptions'] || [];
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    this.updateTimeSlot();
    if (this.userInfo?.isInsurance === '1') {
      const res = await getqdNo();
      this.signNo = res.data?.signNo;
    }
  },
  methods: {
    // 工具函数
    getRandom4Digits() {
      return Math.floor(1000 + Math.random() * 9000).toString();
    },
    getCurrentTimeSlot() {
      const hour = dayjs().hour();
      return hour >= 6 && hour < 12 ? '1' : (hour >= 12 && hour < 18 ? '2' : '3');
    },
    updateTimeSlot() {
      const now = new Date(), totalMinutes = now.getHours() * 60 + now.getMinutes();
      this.patientForm.timeSlot = totalMinutes >= 450 && totalMinutes <= 720 ? '1' : (totalMinutes >= 780 && totalMinutes <= 1080 ? '2' : (totalMinutes >= 1140 && totalMinutes <= 1439 ? '3' : '1'));
    },
    getTimeDetail(timeFrame) {
      return timeFrame === '1' ? '07:30-12:00' : (timeFrame === '2' ? '13:00-18:00' : (timeFrame === '3' ? '19:00-23:59' : '休息时间'));
    },
    formatRegionCode(code, prefixLength, zeroPadding) {
      if (!code || code.length < prefixLength) return code || '';
      return code.substring(0, prefixLength) + '0'.repeat(zeroPadding);
    },
    getAgeAndMonthsFromIdCard(idCard) {
      if (!idCard || idCard.length !== 18) return {years: 0, months: 0, birthday: ''};
      const birthStr = idCard.slice(6, 14),
          birthday = `${birthStr.slice(0, 4)}-${birthStr.slice(4, 6)}-${birthStr.slice(6, 8)}`;
      const birthDate = new Date(birthday);
      if (isNaN(birthDate.getTime())) return {years: 0, months: 0, birthday: ''};
      const today = new Date();
      let years = today.getFullYear() - birthDate.getFullYear();
      let months = (today.getFullYear() - birthDate.getFullYear()) * 12 + (today.getMonth() - birthDate.getMonth());
      if (today.getMonth() < birthDate.getMonth() || (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
        years--;
        months--;
      }
      months = Math.max(0, months % 12);
      return {years, months, birthday};
    },
    async certnoMonitor(val) {
      if (!val.certno) return;
      const certType = this.patientForm.identityCard;
      const lengthRule = certLengthMap[certType];
      const patternRule = certPatterns[certType];
      if (val.certno.length !== lengthRule) {
        this.$message.error(`请输入${lengthRule}位证件号码`);
        return;
      }
      if (patternRule && !patternRule.test(val.certno)) {
        this.$message.error('证件号码格式不正确');
        return;
      }
      if (certType === 1) {
        try {
          const res = await getDoesItExistSFZ({certNo: val.certno.toString()});
          // if (res.data && val.certno !== this.patientChooseForm?.certno) { this.$message.error("该身份证在信息库中已经存在!"); return 1; }
          const genderDigit = parseInt(val.certno.charAt(16), 10);
          val.sex = genderDigit % 2 === 1 ? '1' : '2';
          const ageData = this.getAgeAndMonthsFromIdCard(val.certno);
          val.ageYear = ageData.years;
          val.ageMonth = ageData.months;
          val.brdy = `${val.certno.slice(6, 10)}-${val.certno.slice(10, 12)}-${val.certno.slice(12, 14)}`;
        } catch (error) {
          this.$message.error('身份证验证服务异常');
        }
      } else {
        if (certType === '8') val.sex = '';
        else {
          val.sex = '';
          val.ageYear = '';
          val.ageMonth = '';
          val.brdy = '';
        }
      }
    },
    async dict(data) {
      this.nationOption = data.natyEntities.map(i => ({id: i.id, label: i.name}));
      this.certypeOption = data.certypeEntities.map(i => ({id: i.id, label: i.name}));
      this.profttlOption = data.profttlEntities.map(i => ({id: i.id, label: i.name}));
      this.prhCostOption = data.prhCostType.map(i => ({id: i.id, label: i.name}));
      this.prhTypeOption = data.prhType.map(i => ({id: i.id, label: i.name}));
      this.jobOption = data.jobEntities.map(i => ({id: i.id, label: i.name}));
      this.rltsEntitiesOption = data.rltsEntities.map(i => ({id: i.id, label: i.name}));
      this.untAtteOption = data.unatteVo.map(i => ({id: i.id, label: i.name}));
      this.ntlyOptions = data.country.map(i => ({id: i.id, label: i.name}));
      this.acctUsedFlagOptions = data.acctUsedFlag.map(i => ({id: i.codeValue, label: i.codeValueDesc}));
      this.medTypeOptions = data.medType.map(i => ({id: i.codeValue, label: i.codeValueDesc}));
      this.psnSetlwayOptions = data.psnSetlway.map(i => ({id: i.codeValue, label: i.codeValueDesc}));
    },
    // 支付相关
    async loadPaymentMethods() {
      const res = await getPatternPaymentList();
      if (res.code === 200) this.dynamicPaymentMethods = res.data;
    },
    initDynamicPaymentValuesForRegistration() {
      this.dynamicPaymentValues = {};
      this.dynamicPaymentMethods.forEach(method => {
        let defaultValue = 0;
        if (method.wayCode === 'YB' || method.wayName.includes('医保')) defaultValue = this.outpatientYbRegisterForm.yb_2206_ReturnInfo?.fund_pay_sumamt || 0;
        else if (method.wayCode === 'XJ') defaultValue = this.patientForm.total;
        this.$set(this.dynamicPaymentValues, method.id, defaultValue);
      });
      this.calculateRegistrationPayments();
    },
    calculateRegistrationPayments() {
      let totalPaid = 0;
      this.dynamicPaymentMethods.forEach(m => {
        totalPaid += Number(this.dynamicPaymentValues[m.id]) || 0;
      });
      this.addForm.recdAmt = totalPaid.toFixed(2);
      const shouldPay = Number(this.patientForm.total) || 0;
      this.addForm.change = (totalPaid - shouldPay).toFixed(2);
      if (Number(this.addForm.change) < 0) {
        this.addForm.change = '0.00';
        this.$message.warning('支付金额不足');
      }
    },
    assembleRegistrationPayment() {
      const payWays = [];
      let totalPaid = 0;

      // 1. 收集实际金额 >0 的支付方式
      this.dynamicPaymentMethods.forEach(m => {
        const amount = Number(this.dynamicPaymentValues[m.id]) || 0;
        if (amount > 0) {
          payWays.push({ amount, classId: m.classId, wayId: m.id });
          totalPaid += amount;
        }
      });

      // 2. 如果没有实付金额（totalPaid === 0），则手动添加一条现金支付方式，金额为0
      if (totalPaid === 0) {
        payWays.push({
          amount: 0,
          classId: 101,   // 现金对应的 classId
          wayId: 2        // 现金对应的 wayId (根据你提供的数据)
        });
      }

      return { payWays, totalPaid };
    },
    getPaymentWayIdByCode(code) {
      const m = this.dynamicPaymentMethods.find(m => m.wayCode === code);
      return m ? m.id : 0;
    },
    // 挂号结算
    async handleReservationSettle() {
      if (!this.patientForm.name) return this.$message.warning("请选择患者信息");
      if (!Object.keys(this.rowData).length) return this.$message.warning("请选择挂号信息");
      await withLoading(this, '数据提交中...')(async () => {
        if (this.patientForm.thrNot === 0) await this.handleEditDocphr();
        if (Object.keys(this.outpatientYbRegisterForm.yb_1191_ReturnInfo).length > 0 && !await this.handleYBInfoUpload()) return;
        const price = Number(this.rowData.price) || 0;
        this.patientForm.total = price;
        this.addForm.currentTotal = price;
        this.addForm.recdAmt = price;
        this.addForm.change = 0;
        this.initDynamicPaymentValuesForRegistration();
        this.addModalVisible = true;
      });
    },

// 在 handleConfirmRegistrationPay 中，挂号成功后调用
    async handleConfirmRegistrationPay() {
      await withLoading(this, '支付处理中...')(async () => {
        const { payWays, totalPaid } = this.assembleRegistrationPayment();
        const shouldPay = Number(this.patientForm.total) || 0;
        if (totalPaid < 0) return this.$message.warning("请确认支付金额");
        if (Math.abs(totalPaid - shouldPay) > 0.01) return this.$message.warning("支付金额与应收金额不匹配");

        const registertypeArr = await getCategory({ regTyped: this.rowData.registertypeId });
        const regTableVOS = (registertypeArr.data.costnametableVOS || []).map(item => ({
          costId: item.costid,
          regCostAmt: item.costAmt,
          regCost: item.odcost,
          regDiscountCost: item.bonusAmt
        }));

        const requestParams = {
          age: this.patientForm.thrNot === 0 ? this.patientForm.ageYear : 0,
          cashAmt: payWays.find(p => p.wayId === this.getPaymentWayIdByCode('XJ'))?.amount || 0,
          chsAmt: payWays.find(p => p.wayId === this.getPaymentWayIdByCode('YB'))?.amount || 0,
          discountMoney: 0,
          groupAmt: payWays.find(p => p.wayId === this.getPaymentWayIdByCode('WXZF'))?.amount || 0,
          name: this.patientForm.name,
          patientId: this.patientForm.id,
          payType: 1,
          payWay: payWays,
          receivableMoney: shouldPay,
          receivedMoney: totalPaid,
          regDepId: this.rowData.deptId,
          regDoctorId: this.rowData.doctorId,
          regMode: 1,
          regNum: 1,
          regTableVOS,
          regTime: this.patientForm.registerDate,
          regTypeId: this.rowData.registertypeId,
          regUserId: this.userInfo.staffId,
          remake: this.addForm.remarks || '',
          rgstId: this.rowData.id,
          visitId: null
        };

        const res = await addRegisterList(requestParams);
        if (res.code !== 200) return this.$message.error(res.message);

        // ===== 挂号成功后调用 registrationFee =====
        const registrationId = res.data?.id;
        if (registrationId) {
          // 构建 payWay 数组（从 payWays 转换）
          const feePayWays = payWays.map(p => ({
            amount: p.amount || 0,
            wayId: p.wayId || 0
          }));

          const feeParams = {
            payWay: feePayWays,
            registrationId: registrationId,
            requestNo: this.generateUUID()
          };

          console.log('registrationFee 请求参数:', feeParams);
          const feeRes = await registrationFee(feeParams);
          if (feeRes.code !== 200) {
            this.$message.error(feeRes.message)
          }
        }

        if (this.outpatientYbRegisterForm.yb_1101_ReturnInfo?.baseinfo?.psn_no !== undefined && !(await this.handleYB_2207_Upload(res.data.id))) return;

        if (payWays.some(p => p.wayId === this.getPaymentWayIdByCode('WXZF'))) {
          this.payModalVisible = true;
          this.orderId = res.data.orderId;
          return;
        }

        await this.loadData();
        this.handleCloseForm();
        this.addModalVisible = false;
        this.$message.success('挂号成功');
      });
    },

// 生成 UUID
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },    // 医保相关方法（保持原样，仅简化部分变量）
    async handleYB_1191_Upload(mdtrtCretType) {
      if (this.isRequesting) return false;
      this.isRequesting = true;
      try {
        const ybTemplate = buildYbRequest(this.signNo, '1191', this.userInfo.mdtrtareaAdmvs);
        ybTemplate.body = {
          ...ybTemplate.body,
          input: {
            data: {
              mdtrt_cert_type: mdtrtCretType,
              cardtype: '0',
              businesstype: '01101',
              operatorid: this.userInfo.staffId.toString(),
              operatorname: this.userInfo.staffName,
              officeid: this.userInfo.deptDepts?.find(item => item.id === this.userInfo.selDept)?.specialtyCode || '',
              officename: this.userInfo.deptDepts?.find(item => item.id === this.userInfo.selDept)?.specialtyName || ''
            }
          },
          transType: "ec.query",
          orgId: this.userInfo.clinicCode,
        };
        const res = await addYbRquestData({
          infno: '1191',
          mdtrtareaAdmvs: this.userInfo.mdtrtareaAdmvs,
          data: JSON.stringify(ybTemplate),
          patientId: this.userInfo.staffId,
          patientName: this.userInfo.staffName
        });
        if (res.code !== 200) {
          this.$message.error('交易编号:【1191】请求备份失败: ' + (res.message || '未知错误'));
          return false;
        }
        const initResult = await handleYB_1101_Upload({
          fixmedins_code: this.userInfo.clinicCode,
          infosyscode: res.data.infosyscode,
          infosyssign: res.data.infoSysSign,
          service_url: 'http://10.114.177.55:8080/eapdomain/callService'
        });
        if (!initResult.success) {
          this.$message.error('COM服务初始化失败: ' + initResult.error);
          return false;
        }
        let initData = typeof initResult.data === 'string' ? JSON.parse(initResult.data) : initResult.data;
        if (initData && initData.infcode !== 0) {
          this.$message.warning(initData.err_msg || 'ocx服务初始化异常');
          return false;
        }
        const businessParams = {
          fixmedins_code: this.userInfo.clinicCode,
          infosyscode: res.data.infosyscode,
          infosyssign: res.data.infoSysSign,
          input_data: ybTemplate.body
        };
        const businessResult = await handleYB_Business_Upload(businessParams);
        if (!businessResult.success) {
          this.$message.error('业务处理失败: ' + businessResult.error);
          return false;
        }
        let businessResponse = JSON.parse(businessResult.data);
        if (businessResponse.infcode !== 0) {
          this.$message.warning(businessResult.data.err_msg);
          return false;
        }
        await addYbResponseData({id: res.data.id, infno: '1191', data: JSON.stringify(businessResult)});
        // 自动匹配患者或弹出快速建档（原逻辑省略细节，保持完整）
        let patientData;
        if (mdtrtCretType === '01') {
          patientData = this.docphrOptions?.findIndex(item => item.certno === businessResponse.output.ecinfo.idno);
          if (patientData > 0) {
            this.patientForm.patId = businessResponse.output.ecinfo.idno;
            await this.handleSearch();
            this.$message.success("已自动匹配患者存在信息");
          } else {
            this.$message.warning("健康档案不存在该患者信息,请进行快速建档");
            this.celerityFilingForm.name = businessResponse.output.ecinfo.username;
            this.celerityFilingForm.certno = businessResponse.output.ecinfo.idno;
            await this.certnoMonitor(this.celerityFilingForm);
            this.celerityFilingDialogVisible = true;
          }
        } else if (mdtrtCretType === '03') {
          patientData = this.docphrOptions?.findIndex(item => item.certno === businessResponse.output.cardinfo.certno);
          if (patientData > 0) {
            this.patientForm.patId = businessResponse.output.cardinfo.certno;
            await this.handleSearch();
            this.$message.success("已自动匹配患者存在信息");
          } else {
            this.$message.warning("健康档案不存在该患者信息,请进行快速建档");
            this.celerityFilingForm.name = businessResponse.output.cardinfo.psn_name;
            this.celerityFilingForm.certno = businessResponse.output.cardinfo.certno;
            await this.certnoMonitor(this.celerityFilingForm);
            this.celerityFilingDialogVisible = true;
          }
        }
        this.outpatientYbRegisterForm.yb_1191_ReturnInfo = businessResponse;
        return true;
      } catch (error) {
        this.$message.error('交易编号:【1191】系统异常: ' + (error.message || '未知错误'));
        return false;
      } finally {
        this.isRequesting = false;
      }
    },
    async handleGetPatientYbInfo() {
      return ybOutpatientMedical.handleYB_1101_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        patientForm: this.patientForm
      }).then(r => {
        if (r.success && r.data.infcode !== -1) {
          this.outpatientYbRegisterForm.yb_1101_ReturnInfo = r.data.output;
          return true;
        }
        this.$message.error(r.data.err_msg || r.error);
        return false;
      });
    },
    async handleYB_2201A_Upload() {
      return ybOutpatientMedical.handleYB_2201A_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm,
        patientForm: this.patientForm,
        rowData: this.rowData
      }).then(r => {
        if (r.success && r.data.infcode !== -1) {
          this.outpatientYbRegisterForm.yb_2201A_ReturnInfo = r.data.output.data;
          return true;
        }
        this.$message.error(r.data?.err_msg || r.error);
        return false;
      });
    },
    async handleYB_2202_Upload() {
      return ybOutpatientMedical.handleYB_2202_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm,
        patientForm: this.patientForm
      }).then(r => {
        if (r.success && r.data.infcode !== -1) return true;
        this.$message.error(r.data?.err_msg || r.error);
        return false;
      });
    },
    async handleYB_2203A_Upload() {
      return ybOutpatientMedical.handleYB_2203A_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm,
        rowData: this.rowData
      }).then(r => {
        if (r.success && r.data.infcode !== -1) return true;
        this.$message.error(r.data?.err_msg || r.error);
        return false;
      });
    },
    async handleYB_2204_Upload() {
      return ybOutpatientMedical.handleYB_2204_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm,
        rowData: this.rowData,
        getChargingPriceYbCode: this.getChargingPriceYbCode,
        getRandom4Digits: this.getRandom4Digits
      }).then(r => {
        if (r.success && r.data.infcode !== -1) {
          this.outpatientYbRegisterForm.yb_2204_ReturnInfo = r.data.output.result[0];
          return true;
        }
        this.$message.error(r.data?.err_msg || r.error);
        return false;
      });
    },
    async handleYB_2206_Upload() {
      return ybOutpatientMedical.handleYB_2206_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm,
        rowData: this.rowData
      }).then(r => {
        if (r.success && r.data.infcode !== -1) {
          this.outpatientYbRegisterForm.yb_2206_ReturnInfo = r.data.output.setlinfo;
          return true;
        }
        this.$message.error(r.data?.err_msg || r.error);
        return false;
      });
    },
    async handleYB_2207_Upload(regId) {
      return ybOutpatientMedical.handleYB_2207_Upload({
        signNo: this.signNo,
        userInfo: this.userInfo,
        outpatientYbRegisterForm: this.outpatientYbRegisterForm,
        rowData: this.rowData
      }).then(async r => {
        if (r.success && r.data.infcode !== -1) {
          this.outpatientYbRegisterForm.yb_2207_ReturnInfo = r.data.output.setlinfo;
          await this.addYbRegistrationSettleAccounts(r.data.output.setlinfo, JSON.stringify(r.requestInfo), JSON.stringify(r.data), regId);
          this.outpatientYbRegisterForm = {...this.$options.data.call(this).outpatientYbRegisterForm};
          return true;
        }
        this.$message.error(r.data?.err_msg || r.error);
        await this.handleYB_2202_Upload();
        return false;
      });
    },
    async handleYBInfoUpload() {
      return withLoading(this, '医保处理中...')(async () => {
        if (!(await this.handleGetPatientYbInfo())) return false;
        if (!(await this.handleYB_2201A_Upload())) return false;
        if (!(await this.handleYB_2203A_Upload())) {
          await this.handleYB_2202_Upload();
          return false;
        }
        if (!(await this.handleYB_2204_Upload())) {
          await this.handleYB_2202_Upload();
          return false;
        }
        if (!(await this.handleYB_2206_Upload())) {
          await this.handleYB_2202_Upload();
          return false;
        }
        this.$message.success('医保信息上传成功');
        this.outpatientYbRegisterDialogVisible = false;
        return true;
      });
    },
    async getChargingPriceYbCode(id) {
      const res = await getCategory({regTyped: id});
      if (res.code === 200) return res.data.costnametableVOS.find(item => item.registerid === id);
      this.$message.warning(res.message);
      return false;
    },
    async updateYbRegistrationSettleAccounts(mdtrt_id) {
      const res = await getYbRegistrationSettleAccounts({visitEventId: mdtrt_id});
      if (res.code === 200) {
        res.data.isCanceled = 1;
        await updateYbRegistrationSettleAccounts(res.data);
        return true;
      }
      return false;
    },
    async addYbRegistrationSettleAccounts(data, transactionInputJson, transactionOutputJson, regId) {
      const newItem = {
        patientId: this.patientForm.id,
        accountMutualAidPayment: data.acct_mulaid_pay,
        advanceSelfPaymentAmount: data.preselfpay_amt,
        basicMedicalPoolFundExpenditure: data.hifp_pay,
        cashPaymentAmount: data.psn_cash_pay,
        fullSelfPaymentAmount: data.fulamt_ownpay_amt,
        insuranceType: data.insutype,
        isCanceled: 0,
        liquidationAgency: data.clr_optins,
        liquidationMethod: data.clr_way,
        medicalAssistanceFundExpenditure: data.maf_pay,
        medicalInstitutionSettlementId: data.medins_setl_id,
        occurrenceTime: data.setl_time,
        otherFundExpenditure: data.oth_pay,
        patientName: data.psn_name,
        paymentSequence: data.setl_id,
        personalAccountExpenditure: data.acct_pay,
        personalSettlementMethod: data.clr_way,
        psnNo: data.psn_no,
        remainingBalanceAfterPayment: data.balc - data.acct_pay,
        settlementEventId: data.setl_id,
        settlementSequence: data.setl_id,
        settlementTime: data.setl_time,
        totalFundPayment: data.fund_pay_sumamt,
        transactionInputJson,
        transactionOutputJson,
        visitEventId: this.outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
        regId: regId
      };
      const res = await addYbRegistrationSettleAccounts(newItem);
      return res.code === 200;
    },
    async handleYbSwipingCardOrHumanFace(command) {
      if (command === 'electronic') this.handleYB_1191_Upload('01');
      else if (command === 'YbCard') this.handleYB_1191_Upload('03');
      else if (command === 'identityCard') {
        if (!Object.keys(this.rowData).length) return this.$message.warning("请选择挂号信息");
        this.outpatientYbRegisterDialogVisible = true;
      }
    },
    handleSearchWestDiagnose(query) {
      if (!query || query === this.lastSearchQuery) {
        this.westDiagnoseOptions = [];
        return;
      }
      this.westDiagnoseLoading = true;
      this.lastSearchQuery = query;
      getDocticdList({pageSize: 100, condition: query}).then(res => {
        if (res.code === 200) this.westDiagnoseOptions = res.data.map(item => ({
          id: item.id,
          label: item.chsName,
          code: item.chsCode
        }));
        else this.$message.warning(res.message);
        this.westDiagnoseLoading = false;
      }).catch(() => {
        this.$message.error('搜索失败');
        this.westDiagnoseLoading = false;
      });
    },
    handleGetWestDiagnose(selectedValue) {
      if (!selectedValue) return;
      const selected = this.westDiagnoseOptions.find(item => item.id === selectedValue);
      if (selected?.letngh <= 0) return this.$message.warning("系统异常:请联系管理员");
      this.outpatientYbRegisterForm.dise_codg = selected.label + '-' + selected.code;
    },
    handleOutpatientYbRegisterClose() {
      this.outpatientYbRegisterForm = {...this.$options.data.call(this).outpatientYbRegisterForm};
      this.outpatientYbRegisterDialogVisible = false;
    },
    // 扫码支付
    handlePayDialogOpened() {
      this.resetScanner();
      this.$nextTick(() => {
        const input = this.$refs.paymentCodeInput;
        if (input) {
          input.focus();
          input.$el.querySelector('input').focus();
          this._blurHandler = () => setTimeout(() => input.$el.querySelector('input').focus(), 10);
          input.$el.querySelector('input').addEventListener('blur', this._blurHandler);
        }
      });
    },
    handlePayDialogClosed() {
      this.resetScanner();
      if (this._blurHandler) {
        this.$refs.paymentCodeInput?.$el.querySelector('input')?.removeEventListener('blur', this._blurHandler);
      }
    },
    handleYbElectronicCertificatesOpened() {
      this.resetYbScanner();
      this.$nextTick(() => {
        const input = this.$refs.YbElectronicCertificatesCodeInput;
        if (input) {
          input.focus();
          input.$el.querySelector('input').focus();
          this._ybBlurHandler = () => setTimeout(() => input.$el.querySelector('input').focus(), 10);
          input.$el.querySelector('input').addEventListener('blur', this._ybBlurHandler);
        }
      });
    },
    handleYbElectronicCertificatesDialogClosed() {
      this.resetYbScanner();
      if (this._ybBlurHandler) {
        this.$refs.YbElectronicCertificatesCodeInput?.$el.querySelector('input')?.removeEventListener('blur', this._ybBlurHandler);
      }
    },
    resetScanner() {
      this.scanStatus = 'waiting';
      this.paymentCode = '';
      this.countdown = 5;
      this.errorMessage = '付款失败,请重试';
      cancelAnimationFrame(this.animationFrameId);
      this.$nextTick(() => {
        const input = this.$refs.paymentCodeInput?.$el?.querySelector('input');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },
    resetYbScanner() {
      this.ybScanStatus = 'waiting';
      this.YbElectronicCertificatesCode = '';
      this.ybScanCountdown = 5;
      this.ybErrorMessage = '扫码失败,请重试';
      cancelAnimationFrame(this.ybScanAnimationFrameId);
      this.$nextTick(() => {
        const input = this.$refs.YbElectronicCertificatesCodeInput?.$el?.querySelector('input');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },
    startCountdown() {
      cancelAnimationFrame(this.animationFrameId);
      this.countdown = 5;
      this.countdownStartTime = Date.now();
      const animate = () => {
        const elapsed = Date.now() - this.countdownStartTime;
        const remaining = Math.max(0, 5 - Math.floor(elapsed / 1000));
        this.countdown = remaining;
        if (remaining > 0) this.animationFrameId = requestAnimationFrame(animate);
        else {
          if (this.scanStatus === 'success') this.handleClosePayData();
          this.resetScanner();
        }
      };
      this.animationFrameId = requestAnimationFrame(animate);
    },
    YbElectronicCertificatesStartCountdown() {
      cancelAnimationFrame(this.ybScanAnimationFrameId);
      this.ybScanCountdown = 5;
      this.ybScanCountdownStartTime = Date.now();
      const animate = () => {
        const elapsed = Date.now() - this.ybScanCountdownStartTime;
        const remaining = Math.max(0, 5 - Math.floor(elapsed / 1000));
        this.ybScanCountdown = remaining;
        if (remaining > 0) this.ybScanAnimationFrameId = requestAnimationFrame(animate);
        else {
          this.handleCloseYbScan();
          this.resetYbScanner();
        }
      };
      this.ybScanAnimationFrameId = requestAnimationFrame(animate);
    },
    handleScanComplete(val) {
      clearTimeout(this.scanTimer);
      this.scanTimer = setTimeout(() => {
        val = val.trim();
        if (!val) return;
        const isAlipay = /^(25|26|27|28|29|30)\d{14,22}$/.test(val);
        const isWechat = /^(10|11|12|13|14|15)\d{16}$/.test(val);
        if (!isAlipay && !isWechat) {
          this.$message.error('付款码格式错误');
          this.errorMessage = '付款码格式错误';
          this.scanStatus = 'error';
          this.paymentCode = '';
          this.startCountdown();
          return;
        }
        this.processPayment(val);
      }, 300);
    },
    handleYbScanComplete(val) {
      this.processYbElectronicCertificates(val);
    },
    async processPayment(code) {
      this.scanStatus = 'processing';
      try {
        const res = await sqbPayment({dynamicId: code, orderId: this.orderId});
        if (res.data === 'PAY_SUCCESS') {
          this.scanStatus = 'success';
          this.startCountdown();
        } else if (res.data === 'PAY_IN_PROGRESS') await this.pollPaymentStatus(20);
        else if (res.data === 'PAY_ERROR') {
          this.scanStatus = 'error';
          this.handlePaymentError();
        }
        if (res.code !== 200) this.$message.error(res.message);
      } catch {
        this.handlePaymentError();
      }
    },
    async pollPaymentStatus(maxAttempts) {
      let attempts = 0;
      const poll = async () => {
        attempts++;
        try {
          const res = await sqbPayment({orderId: this.orderId}); // 注意：状态查询接口可能不同，这里保留原逻辑
          if (res.data === 'PAY_SUCCESS') {
            this.scanStatus = 'success';
            this.startCountdown();
          } else if (res.data === 'PAY_ERROR' || attempts >= maxAttempts) {
            this.scanStatus = 'error';
            this.handlePaymentError();
          } else if (attempts < maxAttempts) setTimeout(poll, 2000);
        } catch {
          this.handlePaymentError();
        }
      };
      await poll();
    },
    handlePaymentError() {
      this.scanStatus = 'error';
      this.startCountdown();
      this.$message.error('支付处理失败');
    },
    handleYbScanError() {
      this.ybScanStatus = 'error';
      this.YbElectronicCertificatesStartCountdown();
      this.$message.error('扫描电子凭证处理失败');
    },
    async processYbElectronicCertificates(code) {
      this.ybScanStatus = 'processing';
      const success = await this.handleYB_1191_Upload(code);
      if (success) {
        this.ybScanStatus = 'success';
        this.YbElectronicCertificatesStartCountdown();
      } else {
        this.ybScanStatus = 'error';
        this.handleYbScanError();
      }
    },
    handleClosePayData() {
      this.patientForm = {...this.$options.data.call(this).patientForm};
      this.addForm = {...this.$options.data.call(this).addForm};
      this.tableData = [];
      this.payModalVisible = false;
      this.addModalVisible = false;
    },
    handleCloseYbScan() {
      this.outpatientYbRegisterForm = {...this.$options.data.call(this).outpatientYbRegisterForm};
      this.ybElectronicCertificatesModalVisible = false;
    },
    // 患者信息相关
    async handleSearch(connect) {
      await withLoading(this, '数据加载中...')(async () => {
        const res = await getDocphrList({condtion: this.patientForm.patId,type:1});
        if (connect === 1) {
          this.patientChooseForm = res.data[res.data.length - 1];
          await this.handleChoosePatient();
          return;
        }
        if (res.data.length > 1) {
          this.patientDialogVisible = true;
          this.patientTabelData = res.data;
          this.isInputDisabled = this.patientForm.patId != null;
          return;
        }
        if (res.data.length <= 0) {
          this.$message.warning("没有搜索到相关患者!请在健康档案新增或点击下方快速建档!");
          return;
        }
        this.patientChooseForm = res.data[0];
        await this.handleChoosePatient();
        this.isInputDisabled = this.patientForm.patId != null;
      });
    },
    // 模板中修改（略）

// 方法中：
    async handleChoosePatient(row) {
      const selectedRow = row || this.patientChooseForm;
      if (!selectedRow) {
        this.$message.warning('请选择一条患者记录');
        return;
      }
      this.isInputDisabled = false;
      await withLoading(this, '数据加载中...')(async () => {
        // 处理身份证信息
        const ageData = (() => {
          if (!selectedRow.certno?.trim()) return { ageYear: null, ageMonth: null, brdy: null };
          try {
            const info = this.getAgeAndMonthsFromIdCard(selectedRow.certno);
            return { ageYear: info.years, ageMonth: info.months, brdy: info.birthday };
          } catch { return { ageYear: null, ageMonth: null, brdy: null }; }
        })();
        const matchedUnit = this.contractUnitOption.find(item => item.id === selectedRow.phrUnt);

        // 赋值给 patientForm
        this.patientForm = {
          ...this.patientForm,
          id: selectedRow.id || null,
          patId: selectedRow.patId || '',
          name: selectedRow.name || '',
          sex: selectedRow.sex?.toString() || '1',
          certno: selectedRow.certno || '',
          identityCard: selectedRow.identityCard || 1,
          naty: selectedRow.naty || 3,
          jobId: selectedRow.jobId || null,
          ntlyId: parseInt(selectedRow.ntlyId) || null,
          conerName: selectedRow.conerName || '',
          conerTel: selectedRow.conerTel || '',
          conerRltsId: selectedRow.conerRltsId || null,
          thrNot: selectedRow.thrNot || 0,
          prhType: selectedRow.prhType || null,
          phrUnt: matchedUnit ? selectedRow.phrUnt : null,
          prhCostType: selectedRow.prhCostType || null,
          ...ageData
        };

        // 地址处理
        const regionCode = selectedRow.naplAddCode?.toString() || '';
        const contactRegionCode = selectedRow.conerAddCode?.toString() || '';
        this.patientForm.naplAddCodeArr = [this.formatRegionCode(regionCode, 2, 10), this.formatRegionCode(regionCode, 4, 8), this.formatRegionCode(regionCode, 6, 6), this.formatRegionCode(regionCode, 9, 3), regionCode];
        this.patientForm.conerAddCodeArr = [this.formatRegionCode(contactRegionCode, 2, 10), this.formatRegionCode(contactRegionCode, 4, 8), this.formatRegionCode(contactRegionCode, 6, 6), this.formatRegionCode(contactRegionCode, 9, 3), contactRegionCode];

        await this.loadAndDisplayAddress();
        this.patientDialogVisible = false;
        this.isInputDisabled = true;
      });
    },
    async handleEditDocphr() {
      await withLoading(this, '数据提交中...')(async () => {
        this.patientForm.conerAddCode = this.patientForm.conerAddCodeArr.length ? this.patientForm.conerAddCodeArr[this.patientForm.conerAddCodeArr.length - 1] : '';
        this.patientForm.thrNot = this.patientForm.thrNot ? 1 : 0;
        this.patientForm.age = this.patientForm.ageYear;
        this.patientForm.conerRltsId = this.patientForm.conerRltsId === '' ? null : this.patientForm.conerRltsId;
        const res = await editDocphr(this.patientForm);
        if (res.code === 200) {
          this.patientForm.patId = this.patientForm.certno;
          await this.handleSearch();
        } else this.$message.error(res.message);
      });
    },
    async loadAndDisplayAddress(type = 'coner') {
      try {
        if (this.provinces.length === 0) await this.loadProvincial();
        const codeKey = `${type}AddCodeArr`;
        const codes = this.patientForm[codeKey] || [];
        let currentNodes = this.provinces;
        const loadedCodes = [];
        const addressNames = [];
        const levelConditions = ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code', 'area_t_code'];
        for (let i = 0; i < codes.length; i++) {
          const code = codes[i];
          const level = i + 1;
          let targetNode = currentNodes.find(node => node.areaCode === code);
          if (!targetNode) {
            const parentCode = i > 0 ? codes[i - 1] : undefined;
            const res = await getArea({areaCode: parentCode, areaLevel: level, condtion: levelConditions[i]});
            currentNodes = res.data || [];
            targetNode = currentNodes.find(node => node.areaCode === code);
            if (level === 1) this.provinces = currentNodes;
          }
          if (!targetNode) break;
          loadedCodes.push(code);
          addressNames.push(targetNode.areaName);
          if (!targetNode.leaf && level < 5) {
            const res = await getArea({areaCode: code, areaLevel: level + 1, condtion: levelConditions[level]});
            targetNode.children = res.data || [];
            currentNodes = targetNode.children;
          }
        }
        if (type === 'coner') this.conerPleasett = addressNames.join('/') || '请选择地址';
        else this.celerityConerPleasett = addressNames.join('/') || '请选择地址';
        this.$nextTick(() => {
          this.patientForm[codeKey] = [];
          this.$nextTick(() => {
            this.patientForm[codeKey] = [...loadedCodes];
            this.addressKey = Date.now();
          });
        });
      } catch (error) {
        console.error(`加载${type}地址数据失败:`, error);
      }
    },
    async loadProvincial() {
      const res = await getArea({areaLevel: 1, condtion: 'area_p_code'});
      this.provinces = res.data.map(item => ({areaCode: item.areaCode, areaName: item.areaName, leaf: false}));
    },
    async handleCelerityFiling() {
      this.conerPleasett = '';
      this.celerityFilingDialogVisible = true;
      const sysAddr = this.systemParameterList.find(item => item.type === 5)?.value;
      if (sysAddr && JSON.parse(sysAddr).length) {
        this.celerityFilingForm.conerAddCodeArr = JSON.parse(sysAddr);
        await this.loadSelectedPath('celerityFilingForm');
      }
    },
    async loadSelectedPath(field = 'patientForm') {
      try {
        if (this.provinces.length === 0) await this.loadProvincial();
        const codes = this[field]?.conerAddCodeArr || [];
        if (!codes.length) return;
        let currentNodes = this.provinces;
        const loadedCodes = [];
        const addressNames = [];
        const levelConditions = ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code', 'area_t_code'];
        for (let i = 0; i < codes.length; i++) {
          const code = codes[i];
          const level = i + 1;
          let targetNode = currentNodes.find(node => node.areaCode === code);
          if (!targetNode) {
            const parentCode = i > 0 ? codes[i - 1] : undefined;
            const res = await getArea({areaCode: parentCode, areaLevel: level, condtion: levelConditions[i]});
            currentNodes = res.data || [];
            targetNode = currentNodes.find(node => node.areaCode === code);
            if (level === 1) this.provinces = currentNodes;
          }
          if (!targetNode) break;
          loadedCodes.push(code);
          addressNames.push(targetNode.areaName);
          if (level < 5 && level < codes.length && (!targetNode.children || !targetNode.children.length)) {
            const res = await getArea({areaCode: code, areaLevel: level + 1, condtion: levelConditions[level]});
            targetNode.children = res.data || [];
          }
          if (level < 5 && level < codes.length) currentNodes = targetNode.children || [];
        }
        if (field === 'patientForm') this.conerPleasett = addressNames.join('/') || '请选择地址';
        else this.celerityConerPleasett = addressNames.join('/') || '请选择地址';
        this.$nextTick(() => {
          this[field].conerAddCodeArr = [...loadedCodes];
          this.addressKey = Date.now();
        });
      } catch (error) {
        console.error('地址路径加载失败:', error);
      }
    },
    async handleAddCelerityFiling() {
      const valid = await this.$refs.celerityFilingFormRef.validate();
      if (!valid) return;
      await withLoading(this, '数据提交中...')(async () => {
        this.celerityFilingForm.tel = this.celerityFilingForm.conerTel;
        this.celerityFilingForm.conerAddCode = this.celerityFilingForm.conerAddCodeArr.length ? this.celerityFilingForm.conerAddCodeArr[this.celerityFilingForm.conerAddCodeArr.length - 1] : '';
        const res = await addDocphr(this.celerityFilingForm);
        if (res.code === 200) {
          this.patientForm.patId = this.celerityFilingForm.name;
          await this.handleSearch(1);
          this.handleResetContract();
          this.celerityFilingDialogVisible = false;
        } else this.$message.error(res.message);
      });
    },
    handleResetContract() {
      this.celerityFilingForm = {...this.$options.data.call(this).celerityFilingForm};
      this.$refs.celerityFilingFormRef?.resetFields();
    },
    handleCloseCelerityFiling() {
      this.handleResetContract();
      this.celerityFilingDialogVisible = false;
    },
    handleThrNotChange() {
      const today = dayjs().format('YYYYMMDD');
      const randomChars = Array.from({length: 5}, () => String.fromCharCode(65 + Math.floor(Math.random() * 26))).join('');
      this.celerityFilingForm.name = `三无人员${today}_${randomChars}`;
    },
    handleIdCardData() {
      withLoading(this, '身份证读取中...')(async () => {
        const res = await readIdCard();
        if (this.celerityFilingDialogVisible) {
          if (this.celerityFilingForm.certno && this.celerityFilingForm.certno.trim() !== '') return;
          this.celerityFilingForm.certno = res.cardno;
          this.celerityFilingForm.name = res.name;
          this.celerityFilingForm.naty = getNationalityId(this.ntlyOptions, res.nation) ?? 1;
          const isExist = await this.certnoMonitor(this.celerityFilingForm);
          if (isExist === 1) {
            this.patientForm.patId = res.cardno;
            await this.handleSearch();
            this.$message.success("已自动匹配患者存在信息");
            this.celerityFilingDialogVisible = false;
          }
        } else {
          this.patientForm.patId = res.cardno;
          await this.handleSearch();
        }
      });
    },
    handleKeyPress(event) {
      if (event.key === 'F9' || event.keyCode === 120) {
        event.preventDefault();
        this.handleIdCardData();
      }
    },
    handleCloseForm() {
      this.patientForm = {...this.$options.data.call(this).patientForm};
      this.outpatientYbRegisterForm = {...this.$options.data.call(this).outpatientYbRegisterForm};
      this.celerityFilingForm = {...this.$options.data.call(this).celerityFilingForm};
      this.conerPleasett = '';
      this.isInputDisabled = false;
    },
    // 挂号信息相关
    async loadData() {
      const res = await getActiveList({
        deptId: this.patientForm.department === null ? null : this.patientForm.department,
        regTime: this.patientForm.registerDate.toString(),
        type: parseInt(this.patientForm.timeSlot)
      });
      await this.getDoctorList();
      this.tableData = await Promise.all(res.data.map(async item => {
        const matchedDoctor = this.doctorOptions.find(doctor => doctor.id === item.doctorId);
        return {
          ...item,
          professionalTitle: this.profttlOption.find(t => t.id === matchedDoctor?.titel)?.label,
          price: Number(item.price).toFixed(2),
          amTime: item.smorningTime + '-' + item.emorningTime,
          pmTime: item.safternoonTime + '-' + item.eafternoonTime,
          nightTime: item.snightTime + '-' + item.enightTime
        };
      }));
    },
    async getDoctorList() {
      const res = await getDoctorList();
      this.doctorOptions = res.data.map(item => ({id: item.id, label: item.fullName, titel: item.professionalTitle}));
    },
    async getDeptList() {
      if (this.deptOptions.length) return;
      const res = await getConsultingDepartment();
      this.deptOptions = res.data.map(item => ({id: item.deptId, label: item.deptName}));
    },
    async getRegisterType(row) {
      if (this.registerOptions.length) return;
      const res = await getRegisterType();
      this.registerOptions = res.data.map(item => ({label: item.designation, id: item.id, odcost: item.odcost}));
    },
    getTimeFrameData() {
      this.loadData();
    },
    async handleRowClick(row) {
      await this.getRegisterType(row);
      this.rowData = JSON.parse(JSON.stringify(row));
      this.patientForm.registerType = row.registertypeId;
      this.patientForm.doctor = row.doctorId;
      this.patientForm.total = row.price;
    },
    // 合约单位相关
    async getContuntList() {
      const res = await getContuntList();
      this.contractUnitOption = res.data.map(item => ({id: item.id, label: item.name, code: item.code}));
    },
    handleNameChangeCode(v, i) {
      if (i === 1) this.addUnitForm.pyCode = pinyin(this.addUnitForm.name, {
        pattern: 'first',
        toneType: 'none',
        separator: ''
      }).toLocaleUpperCase();
    },
    async handleAddContractUnit() {
      await withLoading(this, '数据提交中...')(async () => {
        if (this.addUnitForm.id) {
          const res = await editContractUnit(this.addUnitForm);
          if (res.code === 200) await this.getContuntList();
          else this.$message.error(res.message);
        } else {
          const res = await addContractUnit(this.addUnitForm);
          if (res.code === 200) await this.getContuntList();
          else this.$message.error(res.message);
        }
        this.addUnitForm = {...this.$options.data.call(this).addUnitForm};
        this.addUnitModalVisible = false;
      });
    },
    handleCancelContract() {
      this.addUnitForm = {...this.$options.data.call(this).addUnitForm};
      this.addUnitModalVisible = false;
    },
    async handleEditContractUnit(item) {
      const res = await getContractUnit(item.id.toString());
      this.addUnitForm = res.data;
      this.addUnitModalVisible = true;
    },
    handleSaveContractUnit() {
      this.addUnitForm = {...this.$options.data.call(this).addUnitForm};
      this.addUnitModalVisible = true;
    },
    // 其他辅助
    handleCloseConfirmPay() {
      this.dynamicPaymentValues = {};
      this.addForm = {...this.$options.data.call(this).addForm};
      this.addModalVisible = false;
    },
    getColumnWidth(label, prop, tableData) {
      const minWidth = 100, padding = 30;
      const widths = [...(tableData || []).map(item => item?.[prop] ?? ''), label].map(t => this.getTextWidth(String(t)) + padding);
      return Math.max(minWidth, ...widths);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, {column}) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", {class: "table-head", style: "width:100%"}, [column.label]);
    },
    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue == null) return ' ';
      const mapArray = this[col.op];
      if (!mapArray || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    }
  }
};
</script>


<style lang="less" scoped>
.no-icon-datepicker ::v-deep .el-input__prefix {
  display: none;
}

.no-icon-datepicker ::v-deep .el-input__suffix {
  display: none;
}

.no-icon-datepicker ::v-deep .el-input__inner {
  padding-left: 15px;
  padding-right: 15px;
}

.footer-buttons {
  display: flex;
  gap: 10px;
}

.yb-dropdown-menu .el-dropdown-menu__item {
  padding: 5px 15px;
}

.yb-dropdown-menu .el-radio {
  margin-right: 0;
}

.system-tabs /deep/ .el-tabs__content {
  padding: 0;
}

/* 方法2：使用 ::v-deep 选择器（推荐） */
.system-tabs ::v-deep .el-tabs__content {
  padding: 0;
}

/* 表格容器样式 */
.table-container {
  height: 70vh;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* 表格样式 */
.el-table {
  width: 100% !important;
  margin: 0;
  padding: 0;
}

/* 底部按钮区域 */
.custom-dialog-footer {
  padding: 10px 0;
  background: #fff;
}

.main-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh; /* 占满整个屏幕高度 */
  overflow: hidden; /* 防止滚动条影响布局 */
}

.compact-form-box {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 1px solid #e6e6e6; /* 分隔线 */
}

.table-container {
  flex: 1; /* 自动填充剩余空间 */
  width: 100%;
  overflow: auto; /* 表格内容过多时滚动 */
  box-sizing: border-box;
  background: #fff;
}

.dialog-footer {
  text-align: right;
  margin-top: 25px;
  padding-right: 15px;
}

.dialog-footer {
  text-align: right;
  padding: 10px 15px;
  border-top: 1px solid #e1e4e8;
}

::v-deep .el-cascader .el-input__inner::placeholder {
  color: var(--el-text-color-placeholder) !important; /* 使用官方变量 */
}

.form-actions {
  text-align: center;
  margin-top: 20px;
}

.payment-summary {
  background: #f5f7fa;
  padding: 10px;
  border-radius: 4px;
  margin-top: 15px;
}

.amount {
  color: #f56c6c;
  font-weight: bold;
  display: inline-block;
  width: 120px;
  text-align: left;
}

.form-section {
  background: white;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.payment-form {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
}

.MedicenCata {
  height: 100vh;
  display: flex;
  flex-direction: column;
}


/* 表格容器 (90%) */
.table-container {
  flex: 1;
  overflow: auto;
  margin-right: 10px;
}

/* 挂号信息容器 (10%) */
.registration-container {
  flex: 0.1;
  display: flex;
  flex-direction: column;
  min-width: 150px; /* 确保最小宽度 */
}

.registration-box {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
  background-color: #f5f7fa;
  height: 100%;
}

.data-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.data-row .label {
  width: 60px; /* 缩小标签宽度以适应更窄的容器 */
  font-size: 12px;
  color: #606266;
}

.data-row .el-input {
  flex: 1;
}

/* 底部区域样式 */
.footer-container {
  padding: 10px;
}


.footer-buttons {
  display: flex;
  justify-content: flex-end;
  padding: 0 10px;
}

.celerity-filing-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px; /* 增加与表单的距离 */
}

/deep/ .el-dialog__header {
  padding: 18px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

.dialog {
  .addUnitDialog {
    .tabs {
      /deep/ .el-select > .el-input {
        width: 172px;
      }

      /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 172px;
      }

      /deep/ .el-form-item__content {
        display: flex;

        span {
          font-size: 12px;
        }
      }

      .oneLine {
        width: 524px;
        // background-color: indianred;
      }
    }

    /deep/ .el-dialog__title {
      font-size: 15px;
    }

    /deep/ .el-table {
      font-size: 15px;
    }
  }

  .patient-dialog {
    .tabs {
      /deep/ .el-select > .el-input {
        width: 172px;
      }

      /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 172px;
      }

      /deep/ .el-form-item__content {
        display: flex;

        span {
          font-size: 12px;
        }
      }

      .oneLine {
        width: 524px;
        // background-color: indianred;
      }
    }

    /deep/ .el-dialog__title {
      font-size: 15px;
    }

    /deep/ .el-table {
      font-size: 15px;
    }
  }
}

.custom-dialog-footer {
  display: flex;
  justify-content: space-between; /* 左右两侧分开 */
  align-items: center; /* 垂直居中 */
}

.left-buttons,
.right-buttons {
  display: flex;
  gap: 10px; /* 按钮间距 */
}

/* 如果需要右侧按钮组靠右对齐 */
.right-buttons {
  margin-left: 100px;
}

/* 关键样式 */
.input-with-button .el-input-group__append {
  padding: 0; /* 移除默认内边距 */
}

.auto-height-button {
  height: 100% !important; /* 继承父容器高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 4px 4px 0 !important; /* 保持圆角匹配 */
}

/* 确保输入框和按钮高度统一 */
.input-with-button .el-input__inner {
  height: 40px; /* 调整这个值会同时改变按钮高度 */
}

.main {
  padding: 0 6px; /* 调整内边距 */
  display: flex;
  justify-content: space-between;
}


.data-row {
  display: flex;
  margin-bottom: 12px;
  align-items: center;
}

.label {
  width: 70px;
  font-size: 13px;
}

.el-input {
  flex: 1;
}


.side-panel {
  width: 240px;
  padding: 10px;
  background: #f5f7fa;
}

.registration-box {
  background: white;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.data-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.label {
  width: 70px;
  font-size: 13px;
  color: #666;
  margin-right: 4px;
}

.el-input {
  flex: 1;
}

.el-input.is-disabled .el-input__inner {
  background-color: #f5f5f5;
  color: #666;
}

/* 新增样式 */
.register-group {
  width: 50%;
  display: flex;
  gap: 16px;
  margin-top: 8px;
}

/* 调整原有分隔线位置 */
.divider-line {
  width: 100%;
}

/* 强制同行显示 */
.register-type + .clinic-room {
  margin-left: -8px; /* 补偿间距 */
}

/* 关键修复样式 */
.compact-form {
  /* 在原有样式基础上添加 */

  .register-type,
  .clinic-room {
    flex: 1; /* 平分剩余空间 */
    min-width: 240px; /* 最小宽度保证换行后对齐 */
    max-width: 50%; /* 最大不超过50% */

    /deep/ .el-form-item__content {
      width: calc(100% - 90px) !important; /* 匹配label宽度 */
    }
  }

  /* 强制同行显示 */

  .register-type + .clinic-room {
    margin-left: -8px; /* 补偿间距 */
  }

  /deep/ .el-form-item__content {
    margin-left: 0 !important; /* 消除ElementUI默认的左侧间距 */
    width: auto !important; /* 取消固定宽度 */
  }

  /deep/ .el-form-item__label {
    padding-right: 6px !important; /* 标签与输入框间距 */
    width: auto !important; /* 取消标签固定宽度 */
    flex: none !important; /* 禁用flex自动分配 */
  }

  .el-form-item {
    /* 调整整体间距 */
    gap: 4px; /* 标签与控件间距 */

    /* 微调对齐方式 */
    align-items: baseline;
  }

  /* 特殊处理复选框 */

  .el-checkbox {
    margin-left: 2px;

    /deep/ .el-checkbox__label {
      display: none; /* 隐藏默认标签 */
    }
  }

  /* 输入框尺寸补偿 */

  .el-input--mini {
    line-height: 28px;

    /deep/ .el-input__inner {
      padding: 0 8px;
    }
  }
}

.compact-form-box {
  height: auto !important; /* 改为自适应高度 */
}

.compact-form {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px; /* 行列间距 */

  .el-form-item {
    margin: 0;
    display: inline-flex;
    align-items: center;

    /* 标签对齐 */

    /deep/ .el-form-item__label {
      line-height: 28px;
      padding-right: 4px;
    }

    /* 表单控件通用样式 */

    .el-input,
    .el-select,
    .el-date-editor {
      width: 100px; /* 默认宽度 */
    }

    /* 特定字段宽度调整 */

    &[label="性别:"] .el-select {
      width: 70px;
    }


    &[label="职业:"] .el-select {
      width: 130px;
    }

    &[label="病员费别:"] .el-select,
    &[label="病员类型:"] .el-select {
      width: 135px;
    }

    &[label="联系电话:"] .el-input {
      width: 135px;
    }


    &[label="挂号类别:"] .el-select,
    &[label="诊室:"] .el-select {
      width: 300px;
    }

    /* 年龄输入组 */

    .age-input-group {
      display: flex;
      align-items: center;

      .el-input {
        width: 32px !important;

        & + .age-unit {
          margin: 0 2px;
        }
      }
    }

    /* 地址输入组 */

    .age-select-address {
      display: flex;
      align-items: center;
      gap: 4px;

      .el-input {
        width: 60px !important;

        &:nth-last-child(2) {
          width: 150px !important;
        }

        /* 乡镇输入框 */
      }
    }
  }

  /* 分隔线样式 */

  .divider-line {
    width: 100%;
  }
}


.divider-line {
  height: 1px;
  background-color: #ebeef5;
}

.compact-form-box {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 12px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.compact-form {
  font-size: 12px;
}

.el-form-item {
  margin-bottom: 5px;
}

.age-unit {
  margin: 0 5px;
  color: #909399;
  font-size: 12px;
}

.MedicenCata {
  width: 100%;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    .header-icon {
      display: flex;
      align-items: center;
    }
  }

  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>